import { render, staticRenderFns } from "./locationInfo.vue?vue&type=template&id=60700f25"
import script from "./locationInfo.vue?vue&type=script&lang=js"
export * from "./locationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports